// extracted by mini-css-extract-plugin
module.exports = {"division":"style_division__3xaWT","total":"style_total__1ajq9"};